import API from "@/global/request/api";
import axios from "@/global/request/axios";

export default {
  studentWork(params) {
    return axios.get(API.studentWork, params);
  },
  studentWorkDetail(id) {
    return axios.get(API.studentWorkId(id));
  },
  commentList(id, params) {
    return axios.get(API.comment(id), params);
  },
  commentCreate(id, params) {
    return axios.post(API.comment(id), params);
  },
  commentPraise(workId, commentId) {
    return axios.put(API.commentPraise(workId, commentId));
  },
  commentTip(workId, commentId) {
    return axios.put(API.commentTip(workId, commentId));
  },
  commentReply(workId, commentId, params) {
    return axios.post(API.commentReply(workId, commentId), params);
  }
};
